import { arraysMatch } from '../../utils/data';

/**
 * 
 * @param {Array} variants - array of variants
 * @returns {Object} - variant object
 */

const getVariantFromVariantsAndOptions = (variants) => (options) => {
  const variant = variants.find((variant) => arraysMatch(variant.options, options))
  return variant
}

export default getVariantFromVariantsAndOptions;